import { callPost } from "apis";
import { LARAVEL_APP_HOST } from "../constants";
import { LARAVEL_APP_API } from "../constants";
import { AxiosResponse } from "axios";

export class ContactUsAPI {
  async sendFeedback(content: string): Promise<AxiosResponse<any> | null> {
    const deviceDetails = {
      browserVersion: "N/A",
      platform: "N/A",
      appVersion: "N/A",
      userAgent: navigator.userAgent,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
    const fullPath = `${LARAVEL_APP_HOST}${LARAVEL_APP_API}/v1/send`; //https://app.weareatticus.com/api/v1/send
    const response = await callPost(fullPath, {
      content: content + "\n",
      deviceDetails,
    });

    return response;
  }
}
